<template>
  <div>
    <Contenedor
      :datos="datos"
      :datosEnabled="datosEnabled"
      widthCard="146px"
      @openURL="openURL"
      showTitle
    />
  </div>
</template>

<script>
import Contenedor from './Contenedor.vue';

export default {
  props: {
    datos: Object,
    datosEnabled: Number
  },
  components: {
    Contenedor
  },
  methods: {
    openURL (item) {
      let itemID = item.id;

      this.$router.push({
        name: 'indices-tematicos',
        params: { idIndiceTematico: `${itemID}` }
      });
    }
  }
};
</script>
